import { useTheme } from "styled-components";
import SelectComponent from "./SelectComponent"

export default function Select (props) {
    const theme = useTheme();
    return (<SelectComponent {...props} theme={theme} />
    );
  }